import { render } from "./LeeDropdownItem.vue?vue&type=template&id=0458dd5c"
import script from "./LeeDropdownItem.vue?vue&type=script&lang=js"
export * from "./LeeDropdownItem.vue?vue&type=script&lang=js"

import "./LeeDropdownItem.vue?vue&type=style&index=0&id=0458dd5c&lang=css"

import exportComponent from "F:\\leeao\\leeplus_docs_code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__